import Container from '../../../elements/Container'
import LineSeparator from '../../../elements/LineSeparator'
import { addLinkTarget } from '../../../helpers/addLinkTarget'
import styles from './styles.module.scss'

const Title = ({ content, count }) => (
  <Container variant={['-xs2', '-pxl']}>
    <div id={`title-${count}`} className={styles.separator}>
      <LineSeparator variant={['center']} />
    </div>

    <h2 className={styles.title}>{addLinkTarget(content)}</h2>
  </Container>
)

export default Title
